import * as Dialog from '@radix-ui/react-dialog'
import styles from './StausModal.module.css'
import { Dispatch, SetStateAction, useState } from 'react'
import { PaymentTicketWithTransactions } from '../core/_models'
import { internalFinishTicketAPI } from '../core/_requests'
import { ticketChangeErrorText } from '../core/ticketErrors'
import Swal from 'sweetalert2'
import clsx from 'clsx'
import { Spinner } from 'react-bootstrap'
import { useAuth } from '../../auth'

const StatusModal = ({
  isOpen,
  setIsOpen,
  targetTicket,
  setTargetTicket,
  setTickets,
}: {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  targetTicket: PaymentTicketWithTransactions | null
  setTargetTicket: Dispatch<SetStateAction<PaymentTicketWithTransactions | null>>
  setTickets: Dispatch<SetStateAction<PaymentTicketWithTransactions[]>>
}) => {
  const { currentUser } = useAuth()
  const [input, setInput] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const sumbitHandler = async () => {
    setIsLoading(true)
    if (targetTicket?.externalUserId) {
      let response
      try {
        response = await internalFinishTicketAPI(
          targetTicket?.ticketToken,
          String(targetTicket?.externalUserId),
          String(input),
          currentUser
        )
      } catch (e) {
        Swal.fire({ title: 'Ошибка', text: ticketChangeErrorText(e), icon: 'error' })
        setIsLoading(false)
        return
      }
      if (response?.status === 200) {
        setTickets((prev) =>
          prev?.map((el) => {
            return el?.ticketToken === targetTicket?.ticketToken
              ? { ...el, amount: input, ticketStatus: 'COMPLETED' }
              : el
          })
        )
        setTargetTicket(null)
        setIsOpen(false)
        setIsLoading(false)
      } else {
        setTickets((prev) =>
          prev?.map((el) => {
            if (el?.ticketToken === targetTicket?.ticketToken) {
              return { ...el, ticketStatus: 'EXPIRED' }
            }
            return el
          })
        )
        setIsLoading(false)
        setIsOpen(false)
      }
    }
  }

  return (
    <div style={{ position: 'absolute' }}>
      <Dialog.Root open={isOpen}>
        <Dialog.Portal>
          <Dialog.Overlay
            className={styles.overlay}
            onClick={() => {
              setIsOpen(false)
              setTickets((prev: any) => {
                return prev.map((el: PaymentTicketWithTransactions) =>
                  el.ticketToken === targetTicket?.ticketToken
                    ? { ...el, ticketStatus: 'EXPIRED' }
                    : el
                )
              })
            }}
          />
          <Dialog.Content className={clsx(styles.content, 'bg-secondary')}>
            <div className={styles.inpits}>
              <label htmlFor='exampleInputEmail1' className='form-label mb-6'>
                Введите сумму
              </label>
              <input
                type='number'
                min='0'
                className='form-control'
                id='exampleInputEmail1'
                aria-describedby='emailHelp'
                placeholder='Сумма'
                onChange={(e) => setInput(Number(e.target.value))}
              />
            </div>
            <div className={styles.buttons}>
              <button
                onClick={sumbitHandler}
                type='button'
                className={`btn btn-primary c ${input === 0 ? 'disabled' : ''}`}
              >
                {isLoading ? <Spinner className={styles.spinner} /> : 'Завершить'}
              </button>

              <button
                onClick={() => {
                  setIsOpen(false)
                  setTickets((prev: any) => {
                    return prev?.map((el: PaymentTicketWithTransactions) =>
                      el.ticketToken === targetTicket?.ticketToken
                        ? { ...el, ticketStatus: 'EXPIRED' }
                        : el
                    )
                  })
                  setTargetTicket(null)
                }}
                type='button'
                className='btn btn-danger'
                disabled={isLoading}
              >
                Отмена
              </button>
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </div>
  )
}

export default StatusModal
